import React from 'react';
import styled from 'styled-components';
import { emy, fontUbuntu } from '../../utilities/utilities';

import Exclamation from 'react-icons/lib/fa/exclamation-triangle';

const ErrorContainer = styled.div`
  position:relative;
  display: flex;
  color: rgba(239,59,59,1);
  padding: 0.5rem 0 0 0;
  align-items: center;
  text-rendering: optimizeLegibility;
`;

const ErrorField = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-self: flex-start;
`;

const ErrorText = styled.span`
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntu};
  font-size: ${emy(14)};
  font-weight: bold;
  flex: 1 1 auto;
`;

const StyledExclamation = styled(Exclamation)`
  margin-right: 0.5rem;
  font-size: ${emy(15)};
  display: block;
`

const Error = (props) => {
  return (
    <ErrorContainer>
      <ErrorField>
        <StyledExclamation/>
      </ErrorField>
      <ErrorText>{props.children}</ErrorText>
    </ErrorContainer>
  ); 
};

export default Error;


// WEBPACK FOOTER //
// ./src/components/Form/FormError.js